import styled from "@emotion/styled";

/**
 * 드롭다운 목록 맨 위에 두는 '직접 입력' 옵션.
 * 선택하면 아래 목록 대신 입력 폼이 열려서, 직접 입력을 고른 상태가 눈에 보인다.
 */
export const CustomOptionItem = styled.button<{ selected: boolean }>(
  ({ theme, selected }) => ({
    width: "100%",
    padding: "10px 20px",
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    fontWeight: selected ? theme.fontWeight.bold : theme.fontWeight.regular,
    color: theme.color.black,
    backgroundColor: selected ? theme.color.border_gray : theme.color.white,
    border: "none",
    borderBottom: `1px solid ${theme.color.border_gray}`,
    textAlign: "start",
    cursor: "pointer",
    ":hover": { backgroundColor: theme.color.border_gray },
  }),
);

export const CustomRadio = styled.span<{ selected: boolean }>(
  ({ theme, selected }) => ({
    width: "1.6rem",
    height: "1.6rem",
    borderRadius: "50%",
    flexShrink: 0,
    border: `1px solid ${selected ? theme.color.black : theme.color.light_gray}`,
    backgroundColor: selected ? theme.color.black : "transparent",
    boxShadow: selected ? `inset 0 0 0 3px ${theme.color.white}` : "none",
  }),
);

export const CustomCheck = styled.span({ marginLeft: "auto", fontSize: "1.4rem" });
